/**
 * Kod akcji z historii pracy dotyczącej leków → klucz tłumaczenia z sekcji WORK-HISTORY.
 *
 * Kody nadaje backend (poza tym repo) i przychodzą w obu konwencjach naraz: obok
 * camelCase (`editMedicineSchedule`) w tej samej tabeli stoi snake_case
 * (`alarm_zone_update`, `mfa_succes`). Tłumaczenie pod dokładnym kodem łapie więc tylko
 * te warianty, które ktoś zdążył wpisać do plików i18n — reszta pokazuje w tabeli surowy
 * kod z bazy. Zamiast dopisywać kolejne pisownie rozkładamy kod na dziedzinę (lek albo
 * harmonogram dawkowania) i czasownik, i składamy z nich jeden z sześciu kluczy, które
 * sekcja WORK-HISTORY zna.
 *
 * Czysta funkcja, bez zależności od Angulara — testuje się bez TestBed.
 */

/**
 * Sam fragment „medic" (tak dopasowuje się ikona) tutaj nie wystarczy: złapałby też
 * kartę medyczną — `edit_medical_info` opisywałoby się wtedy jako edycja leku.
 */
const MEDICINE_DOMAIN = /medicine|medication|drug/;

/** Kolejność bez znaczenia: kod akcji niesie tylko jeden czasownik. */
const VERBS: Array<{ verb: string, pattern: RegExp }> = [
  { verb: 'add', pattern: /add|create/ },
  { verb: 'edit', pattern: /edit|update|change|modify/ },
  { verb: 'delete', pattern: /delete|remove/ }
];

/**
 * `null` = to nie jest akcja na lekach albo nie da się z niej odczytać czasownika;
 * wtedy wywołujący zostaje przy swoim dotychczasowym zachowaniu.
 */
export function toMedicineActionKey(action: string): string {
  const a = (action || '').toString().toLowerCase();
  if (!MEDICINE_DOMAIN.test(a)) {
    return null;
  }
  const matched = VERBS.filter(candidate => candidate.pattern.test(a))[0];
  if (!matched) {
    return null;
  }
  return 'WORK-HISTORY.' + matched.verb + (a.indexOf('schedule') !== -1 ? 'MedicineSchedule' : 'Medicine');
}
